import metadataToInputMetadata from "hoxton-shared/utils/metadataToInputMetadata";
import { TemplateType } from "hoxton-shared/enums/masterTemplate";

import type { ConstructedDeliverable } from "@/types/types";

import { useParams } from "@/composables/useParams";
import computedValuesToComputedOverwrites from "@/utils/computedValuesToComputedOverwrites";

export function usePreviewValues() {
    const { campaignId } = useParams();

    function previewValues(deliverable: ConstructedDeliverable) {
        const computedOverwrites = computedValuesToComputedOverwrites(deliverable.computedValues);

        const metadata = [
            {
                fieldName: "language",
                value: deliverable.language
            },
            ...metadataToInputMetadata(deliverable.metadata ?? [])
        ];

        return JSON.stringify({
            computedOverwrites,
            metadata,
            masterTemplate: {
                _id: deliverable.masterTemplate._id,
                persistentKey: deliverable.masterTemplate.persistentKey,
                width: deliverable.masterTemplate.width,
                height: deliverable.masterTemplate.height,
                aeInfo:
                    deliverable.masterTemplate.adType === TemplateType.AE
                        ? {
                              completed: deliverable.masterTemplate?.aeInfo?.completed,
                              plainlyProjectId: deliverable.masterTemplate?.aeInfo?.plainlyProjectId,
                              plainlyTemplateId: deliverable.masterTemplate?.aeInfo?.plainlyTemplateId
                          }
                        : null,
                reportingLabel: deliverable.masterTemplate.reportingLabel
            },
            previewUrl: deliverable.masterTemplate.preview,
            campaignId: campaignId.value,
            reportingLabel: deliverable.reportingLabel
        });
    }

    return previewValues;
}
